import { useApolloClient } from "@apollo/client";
import React from "react";
import { useInviteOrganisationMemberMutation } from "./InviteOrganisationMemberModal.generated.js";
import {
  type MemberInvitee,
  type OrganisationMembershipInvitationEmailFormValues,
  useOrganisationMembershipInvitationEmailForm,
} from "./useOrganisationMembershipInvitationEmailForm.js";

export type { OrganisationMembershipInvitationEmailFormValues } from "./useOrganisationMembershipInvitationEmailForm.js";

export function useOrganisationMembershipInvitation({
  refetchQueries,
  invitee,
}: {
  refetchQueries: string[];
  invitee: MemberInvitee;
}) {
  const {
    formFields,
    emailFieldsData,
    initialValues,
    validationSchema,
    templatesLoading,
    templatesError,
  } = useOrganisationMembershipInvitationEmailForm({ invitee });

  const client = useApolloClient();
  const [invite, { loading: isLoading }] = useInviteOrganisationMemberMutation({
    client,
    refetchQueries,
    awaitRefetchQueries: true,
  });

  const createSubmitHandler = React.useCallback(
    (userId: string) =>
      async (values: OrganisationMembershipInvitationEmailFormValues) => {
        await invite({
          variables: {
            input: {
              userId,
              messageSubject: values.subject,
              messageBody: values.message,
            },
          },
        });
      },
    [invite]
  );

  return {
    formFields,
    emailFieldsData,
    validationSchema,
    initialValues,
    createSubmitHandler,
    isLoading,
    templatesLoading,
    templatesError,
  };
}
